import { store } from "../../..";
import { API } from "../../../../legacy/api";
import { showError } from "../../../utils/errorHandler";
import * as validate from "../../../validation";
import { IAutoplaySetting } from "./AutoplaySettings";
import * as actions from "./AutoplaySettings.actions";

API.on("autoplay.available.set", (available: boolean) => {
  if (store.getState().autoplay.available !== available) {
    store.dispatch(actions.setAvailable(available));
  }
});
API.on("autoplay.roundsleft.set", (rounds: number) => {
  if (validate.roundsLeft(rounds)) {
    store.dispatch(actions.setRoundsLeft(rounds));
  }
});

API.on("autoplay.roundsvalues.set", (roundsValues: number[]) => {
  if (validate.roundsValues(roundsValues, "API:autoplay.roundsvalues.set")) {
    store.dispatch(actions.setRoundsValues(roundsValues));
  }
});

API.on("autoplay.rounds.set", (rounds: number) => {
  if (validate.rounds(rounds)) {
    store.dispatch(actions.selectRounds(rounds));
  }
});

API.on("autoplay.start", () => {
  const {
    allowAutoplayStart,
    running,
    roundsSelected
  } = store.getState().autoplay;

  if (running) {
    showError("Autoplay cannot be started. Already running.");
  } else if (!roundsSelected) {
    showError("Autoplay cannot start. Rounds must be selected.");
  } else if (!allowAutoplayStart) {
    showError("Autoplay cannot start. Required settings must valid.");
  } else {
    store.dispatch(actions.startAutoplay());
  }
});

API.on("autoplay.stop", () => {
  store.dispatch(actions.stopAutoplay());
});

API.on("autoplay.settings.set", (settings: IAutoplaySetting[]) => {
  if (validate.autoplaySettings(settings, "API:autoplay.settings.set")) {
    store.dispatch(actions.setSettings(settings));
  }
});

API.on("autoplay.setting.set", (setting: IAutoplaySetting) => {
  if (validate.autoplaySetting(setting, "API:autoplay.settings.set")) {
    store.dispatch(actions.updateSetting(setting));
  }
});

API.on("autoplay.rounds.reset", () => {
  store.dispatch(actions.resetRounds());
});
